<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="6">
        <el-card>
          <div class="top_title">
访问次数（PV）
</div>
          <div class="top_number">
            {{ view_count.total }}
          </div>
          <div>
            <span class="top_date">今日</span>
            <span class="top_little_number">{{ view_count.today }}</span>
          </div>
          <div>
            <span class="top_date">昨日</span>
            <span class="top_little_number">{{ view_count.yesterday }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div class="top_title">
提交人数
</div>
          <div class="top_number">
            {{ submit_count.total }}
          </div>
          <div>
            <span class="top_date">今日</span>
            <span class="top_little_number">{{ submit_count.today }}</span>
          </div>
          <div>
            <span class="top_date">昨日</span>
            <span class="top_little_number">{{ submit_count.yesterday }}</span>
          </div>
        </el-card>
</el-col><el-col :span="6">
        <el-card>
          <div class="top_title">
核销人数
</div>
          <div class="top_number">
            {{ verify_count.total }}
          </div>
          <div>
            <span class="top_date">今日</span>
            <span class="top_little_number">{{ verify_count.today }}</span>
          </div>
          <div>
            <span class="top_date">昨日</span>
            <span class="top_little_number">{{ verify_count.yesterday }}</span>
          </div>
        </el-card>
</el-col><el-col :span="6">
        <el-card>
          <div class="top_title">
到店率
</div>
          <div class="top_number">
            {{ conversion.total }}
          </div>
          <div><span class="top_date">&nbsp;</span> <span class="top_little_number" /></div>
          <div><span class="top_date">&nbsp;</span> <span class="top_little_number" /></div>
        </el-card>
      </el-col>
    </el-row>
    <br>
    <div class="f-table-block">
      <div class="top">
        <div class="left">
          <div class="title">
活动数据分析
</div>
          <div class="text">
每日访问次数、提交人数、核销人数的数据趋势 ¸
</div>
        </div>
        <div class="right">
          <el-radio-group
v-model="radio"
@change="changeDate"
>
            <el-radio-button label="近七日" />
            <el-radio-button label="自定义" />
          </el-radio-group>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-date-picker
            v-model="daterange"
            :class="radio === '近七日' ? 'hide' : ''"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="selectDate"
          />
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>

          <el-select
v-model="value"
placeholder="按渠道分析"
@change="selectChanged('chart')"
>
            <el-option
              v-for="item in channelList"
              :key="item.channel_id"
              :label="item.channel_name"
              :value="item.channel_id"
            />
          </el-select>
        </div>
      </div>
      <div id="container" />
    </div>
    <br>
    <div class="f-search-block">
      <el-form
:inline="true"
:model="formInline"
>
        <el-form-item label="客户手机">
          <el-input
v-model="formInline.mobile"
placeholder="请输入客户手机"
/>
        </el-form-item>
        <el-form-item label="提交时间">
          <el-date-picker
            v-model="formInline.daterange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="来源渠道">
          <el-select
            v-model="formInline.channel_id"
            placeholder="按渠道分析"
            @change="selectChanged('formInline')"
          >
            <el-option
              v-for="item in channelList"
              :key="item.channel_id"
              :label="item.channel_name"
              :value="item.channel_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
type="primary"
@click="onSubmit"
>
查询
</el-button>
          <el-button
type="primary"
plain
@click="downloadVisible = true"
>
导出数据
</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="gap"></div> -->
    <div class="f-table-block">
      <el-table
:data="tableData"
style="width: 100%"
>
        <el-table-column
prop="mobile"
label="手机号"
width="180"
/>
        <el-table-column
prop="channel_name"
label="来源渠道"
width="180"
/>
        <el-table-column
prop="created_at"
label="提交时间"
width="180"
/>
        <el-table-column
prop="statusSwitch"
label="核销状态"
width="180"
/>
        <el-table-column
prop="verified_at"
label="核销时间"
width="180"
/>
        <el-table-column
prop="verify_person"
label="核销员工"
width="180"
/>
        <el-table-column
prop="verify_store"
label="核销门店"
width="180"
/>
        <el-table-column
fixed="right"
label="操作"
width="150"
>
          <template slot-scope="scope">
            <el-button
type="text"
size="small"
@click="handleInfo(scope.row)"
>
              查看信息
            </el-button>
            <el-button
              v-if="scope.row.status !== 1"
              type="text"
              size="small"
              @click="handleRemark(scope.row)"
            >
              导购备注
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-pagination"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
:visible.sync="downloadVisible"
width="60%"
>
      <el-form
ref="form"
:model="downloadForm"
label-width="80px"
>
        <el-form-item
label="导出范围"
prop="date"
>
          <el-date-picker
            v-model="downloadForm.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <el-button
type="text"
@click="goExportList"
>
查看导出列表
</el-button>
        </el-form-item>
        <el-form-item label="来源渠道">
          <el-select
            v-model="downloadForm.channel_id"
            placeholder="按渠道分析"
            @change="selectChanged(downloadForm)"
          >
            <el-option
              v-for="item in channelList"
              :key="item.channel_id"
              :label="item.channel_name"
              :value="item.channel_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
v-if="has_prize"
label="核销状态"
>
          <el-radio-group v-model="downloadForm.status">
            <el-radio label="已核销" />
            <el-radio label="待核销" />
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
type="primary"
@click="handleDownload"
>
立即创建
</el-button>
          <el-button
            @click="
              downloadVisible = false
              downloadForm = {}
            "
          >
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
:visible.sync="infoVisible"
width="40%"
title="客户信息"
>
      <div
v-for="(item, index) in infoDetail"
:key="index"
>
        <el-row>
          <el-col :span="5">
            <span>{{ item.name }}</span>
          </el-col>
          <el-col :span="12">
            <span>{{ item.value }}</span>
          </el-col>
        </el-row>
        <br>
      </div>
      <div
v-for="(u, i) in imgUrlList"
:key="i"
>
        <el-row>
          <el-col :span="5">
            <span>{{ u.name }}</span>
          </el-col>
          <el-col :span="12">
            <div
v-for="(a, b) in u.value"
:key="b"
>
              <el-image
                style="width: 100px; height: 100px; cursor: pointer"
                :src="a"
                @click="showPic(a)"
              />
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row />
    </el-dialog>
    <el-dialog
:visible.sync="remarkVisible"
width="40%"
title="导购备注"
>
      {{ remarkInfo }}
    </el-dialog>
    <el-dialog
:visible.sync="dialogVisible"
width="40%"
>
      <el-row
type="flex"
justify="center"
>
        <img
:src="picUrl"
class="pic"
>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { Column } from '@antv/g2plot'
import moment from 'moment'

export default {
  data () {
    return {
      id: '',
      radio: '近七日',
      daterange: null,
      channelList: [],
      value: '',
      formInline: {
        mobile: '',
        daterange: null,
        value: null,
        page: 1,
        page_size: 20
      },
      total_count: 0,
      tableData: [],
      downloadVisible: false,
      downloadForm: {
        date: null,
        value: null,
        status: ''
      },
      conversion: {},
      submit_count: {},
      verify_count: {},
      view_count: {},
      stackedColumnPlot: null,
      infoVisible: false,
      remarkVisible: false,
      remarkInfo: '',
      has_prize: false,
      infoDetail: [],
      imgUrlList: [],
      url: '',
      picUrl: '',
      dialogVisible: false
    }
  },
  watch: {
    infoVisible (val) {
      if (!val) {
        this.infoDetail = []
        this.imgUrlList = []
      }
    }
  },
  created () {
    const { id } = this.$route.params
    this.id = id
    if (+id) {
      this.fetch(+id)
      this.onSubmit()
    }
  },
  mounted () {
    const data = { activity_id: this.id }
    this.draw(data)
  },
  methods: {
    async fetch () {
      const data = await this.$api.formActivity.fetchRealTimeCount({ activity_id: this.id })
      if (data) {
        this.conversion = data.conversion || ''
        this.submit_count = data.submit_count || ''
        this.verify_count = data.verify_count || ''
        this.view_count = data.view_count || ''
      }
      const params = { page: 0 }
      params.activity_id = this.id
      const data2 = await this.$api.formActivity.listChannel(params)
      if (data2) {
        this.channelList = [
          {
            channel_id: 0,
            channel_name: '全部'
          },
          ...data2.list
        ]
      }
    },
    async draw (data) {
      const data2 = await this.$api.formActivity.fetchEveryTimeCount(data)
      if (this.stackedColumnPlot) {
        this.stackedColumnPlot.update({
          data: data2,
          isGroup: true,
          xField: 'date',
          yField: 'count',
          seriesField: 'name',
          /** 设置颜色 */
          //color: ['#1ca9e6', '#f88c24'],
          /** 设置间距 */
          // marginRatio: 0.1,
          label: {
            // 可手动配置 label 数据标签位置
            position: 'middle', // 'top', 'middle', 'bottom'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              { type: 'interval-adjust-position' },
              // 数据标签防遮挡
              { type: 'interval-hide-overlap' },
              // 数据标签文颜色自动调整
              { type: 'adjust-color' }
            ]
          }
        })
      } else {
        this.stackedColumnPlot = new Column('container', {
          data: data2,
          isGroup: true,
          xField: 'date',
          yField: 'count',
          seriesField: 'name',
          /** 设置颜色 */
          //color: ['#1ca9e6', '#f88c24'],
          /** 设置间距 */
          // marginRatio: 0.1,
          label: {
            // 可手动配置 label 数据标签位置
            position: 'middle', // 'top', 'middle', 'bottom'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              { type: 'interval-adjust-position' },
              // 数据标签防遮挡
              { type: 'interval-hide-overlap' },
              // 数据标签文颜色自动调整
              { type: 'adjust-color' }
            ]
          }
        })

        this.stackedColumnPlot.render()
      }
    },
    onSubmit () {
      this.formInline.page = 1
      this.getList()
    },
    // 列表分页
    handleSizeChange (val) {
      this.formInline.page = 1
      this.formInline.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    async handleDownload () {
      const params = {}
      if (this.downloadForm.status === '已核销') {
        params.status = 2
      }
      if (this.downloadForm.status === '待核销') {
        params.status = 1
      }
      params.activity_id = this.id
      if (params.start_date) {
        params.start_date = moment(this.downloadForm.date[0]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (params.end_date) {
        params.end_date = moment(this.downloadForm.date[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      params.file_type = 22
      params.channel_id = this.downloadForm.channel_id
      const data = await this.$api.file.createExportList(params, 22).catch(() => {
        // this.createLoading = false
      })
      if (data && data.download_data) {
        // this.createLoading = false
        const a = document.createElement('a')
        a.href = data.download_data.url
        a.download = data.download_data.file_name
        a.click()
      } else if (data && !data.download_data) {
        this.$message({
          message: '请求成功，异步处理中，请稍后到 导出列表 进行下载！',
          type: 'success'
        })
      }
    },
    selectDate () {
      const data = {
        activity_id: this.id,
        start_date: moment(this.daterange[0]).format('YYYY-MM-DD'),
        end_date: moment(this.daterange[1]).format('YYYY-MM-DD'),
        channel_id: this.value
      }
      this.draw(data)
    },
    changeDate () {
      if (this.radio === '近七日') {
        const data = {
          activity_id: this.id,
          channel_id: this.value
        }
        this.draw(data)
      }
    },
    async getList () {
      const params = this.formInline
      if (this.formInline.daterange) {
        params.start_date = moment(this.formInline.daterange[0]).format('YYYY-MM-DD')
        params.end_date = moment(this.formInline.daterange[1]).format('YYYY-MM-DD')
      }
      params.activity_id = this.id
      const data = await this.$api.formActivity.fetchActivityRecordList(params)
      if (data) {
        this.tableData = data.list.map((v) => {
          if (v.status === 0) {
            v.statusSwitch = '无需核销'
          }
          if (v.status === 1) {
            v.statusSwitch = '待核销'
          }
          if (v.status === 2) {
            v.statusSwitch = '已核销'
          }
          return v
        })
        this.total_count = data.total_count
        this.has_prize = data.has_prize
      }
    },
    selectChanged (type) {
      if (type === 'chart') {
        let data = {}
        if (this.radio === '自定义') {
          data = {
            activity_id: this.id,
            start_date: moment(this.daterange[0]).format('YYYY-MM-DD'),
            end_date: moment(this.daterange[1]).format('YYYY-MM-DD'),
            channel_id: this.value
          }
        } else {
          data = {
            activity_id: this.id,
            channel_id: this.value
          }
        }
        this.draw(data)
      }
    },
    async handleInfo (data) {
      this.infoVisible = true
      const data2 = await this.$api.formActivity.fetchActivityRecordInfo({ id: data.id })
      let record_info = JSON.parse(data2.record_info)
      record_info.map((v) => {
        if (v.id.indexOf('SelectDate') > -1) {
          if (v.val.date && v.val.time) {
            this.infoDetail.push({
              name: v.title,
              value: `${v.val.date} ${v.val.time}`
            })
          } else if (v.val.date) {
            this.infoDetail.push({
              name: v.title,
              value: `${v.val.date}`
            })
          } else if (v.val.time) {
            this.infoDetail.push({
              name: v.title,
              value: `${v.val.time}`
            })
          }
        } else if (v.id.indexOf('SelectCity') > -1) {
          this.infoDetail.push({
            name: v.title,
            value: v.val
          })
        } else if (v.id.indexOf('Select') > -1 || v.id.indexOf('Radio') > -1) {
          let result = []
          v.struct.map((e) => {
            if (e.value === v.val) {
              result.push(e.label)
            }
          })
          this.infoDetail.push({
            name: v.title,
            value: result.toString()
          })
        } else if (v.id.indexOf('Checkbox') > -1) {
          let result = []
          v.val.map((c) => {
            v.struct.map((e) => {
              if (e.value === c) {
                result.push(e.label)
              }
            })
          })
          this.infoDetail.push({
            name: v.title,
            value: result.toString()
          })
        } else if (!v.struct) {
          if (v.id.indexOf('UploadImg') > -1) {
            let list = []
            v.val.map((a) => {
              list.push(a.base64Url)
            })
            this.imgUrlList.push({
              name: v.title,
              value: list
            })
          } else {
            this.infoDetail.push({
              name: v.title,
              value: v.val
            })
          }
        }
      })
    },
    handleRemark (data) {
      this.remarkVisible = true
      this.remarkInfo = data.remark
    },
    goExportList () {
      this.$router.push({
        path: '/staffManagement/exportList?filestype=22',
        replace: true
      })
    },
    showPic (data) {
      console.log(data)
      this.picUrl = data
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.top_title {
  color: rgb(170, 170, 170);
  font: size 12px;
  font-weight: normal;
}
.top_number {
  font-size: 32px;
  color: rgb(96, 98, 102);
}
.top_date {
  font-size: 12px;
  color: rgb(170, 170, 170);
}
.top_little_number {
  font-size: 14px;
  color: #606266;
}
.is-always-shadow {
  box-shadow: none !important;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  color: rgb(51, 51, 51);
  font-size: 16px;
}
.text {
  color: rgb(156, 159, 166);
  font-size: 12px;
}
.right {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.hide {
  visibility: hidden;
}
.f-search-block {
  padding-bottom: 0 !important;
}
.pic {
  max-width: 600px;
  max-height: 600px;
}
</style>
